module.exports = __webpack_public_path__ + "img/icon-tlp.ed0d80e8.svg";